import { render, staticRenderFns } from "./baseargencobrosymoratardia.vue?vue&type=template&id=2c5a3b71"
import script from "./baseargencobrosymoratardia.vue?vue&type=script&lang=js"
export * from "./baseargencobrosymoratardia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports